var ko = require('knockout');

// A module that provides the properties and methods necessary for managing a
// set of tabs as part of a larger view model. This is typically mixed into a
// full-page viewmodel that's responsible with keeping track of which tab on
// the page is active.
//
// Provided properties/observables:
//   currentTab - Observable (read/write) with String tab ID or null.
//
// Provided methods:
//   isCurrentTab - Returns true if the given tab ID is current.
//
module.exports = {
  init: function() {
    // String ID of the currently selected tab.
    this.currentTab = ko.observable(null);
  },

  // Public: Check if the current tab is the tab with a certain ID.
  //
  // Returns nothing.
  isCurrentTab: function(tabId) {
    return this.currentTab() === tabId;
  }
};
